var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"word-diff-mark"},[_c('div',{staticClass:"right"},[_c('i'),_c('span',[_vm._v("正确")])]),_c('div',{staticClass:"removed"},[_c('i'),_c('span',[_vm._v("(漏写)")])]),_c('div',{staticClass:"added"},[_c('i'),_c('span',[_vm._v("不计分")])])])
}]

export { render, staticRenderFns }